import React from "react";
import {InProgress} from "../common/InProgress/InProgress";

export const Settings = ()=> {
    return (
        <InProgress/>
    )
}